import {CreateGtaRateRequest} from "@/Stub/V1";
import {useMutation} from "@tanstack/react-query";
import {processValidationErrors} from "@/Util/Api/processValidationErrors";
import {GtaRatesApiClient} from "@/Service/Api/V1/ApiClients/GtaRatesApiClient";

export const useCreateGtaRate = () => useMutation({
    mutationFn: async (data: CreateGtaRateRequest) => {
        try {
            return await GtaRatesApiClient.createGtaRate(data);
        } catch (error) {
            await processValidationErrors(error);
            throw error;
        }
    }
});